import { render, staticRenderFns } from "./BerthPlanningSVG.vue?vue&type=template&id=4f95ff96&scoped=true"
import script from "./BerthPlanningSVG.vue?vue&type=script&lang=js"
export * from "./BerthPlanningSVG.vue?vue&type=script&lang=js"
import style0 from "./BerthPlanningSVG.vue?vue&type=style&index=0&id=4f95ff96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f95ff96",
  null
  
)

export default component.exports